import { PersonalizedProductsModelNames } from 'types/graphql';

import { GetRecommendationsFallback, Options, Scenarios } from './recommendations.types';
import { usePersonalizedItemsV2, UsePersonalizedItemsV2Return } from './use-personalized-items-v2';

/**
 * Maps Scenarios to PersonalizedProductsModelNames for the V2 implementation
 */
function getModelNameFromScenario(scenario: Scenarios): PersonalizedProductsModelNames {
  switch (scenario) {
    case Scenarios.cart1:
      return PersonalizedProductsModelNames.cartToppers;
    case Scenarios.productDetailsPage1:
      return PersonalizedProductsModelNames.relatedItems;
    case Scenarios.productDetailsPage2:
      return PersonalizedProductsModelNames.oftenBoughtWith;
    default:
      return PersonalizedProductsModelNames.recommendedForYou;
  }
}

export function usePersonalizedItems(
  getRecommendationsFallback: GetRecommendationsFallback,
  itemIds: string[],
  scenario: Scenarios,
  options: Options
): UsePersonalizedItemsV2Return {
  const modelName = getModelNameFromScenario(scenario);
  return usePersonalizedItemsV2(getRecommendationsFallback, itemIds, modelName, {
    ...options,
    excludeProducts: itemIds,
  });
}
